module.exports = __webpack_public_path__ + "static/media/clothes_03.b4875dfc.png";